import * as z from 'zod';

import type {
    ModifyDeliveryTimeWindowRequest,
    ModifyProvidedServiceTimeWindowRequest,
} from '@repo/api-types/order-update';

export const OrderUpdateCommandType = {
    ModifyDeliveryTimeWindow: 'ModifyDeliveryTimeWindowRequest',
    ModifyProvidedServiceTimeWindow: 'ModifyProvidedServiceTimeWindowRequest',
} as const;

export type OrderUpdateCommandTypeValue = (typeof OrderUpdateCommandType)[keyof typeof OrderUpdateCommandType];

/**
 * Discriminated union types with literal type discriminators
 */
export interface ModifyDeliveryTimeWindowCommand extends Omit<ModifyDeliveryTimeWindowRequest, 'type'> {
    type: typeof OrderUpdateCommandType.ModifyDeliveryTimeWindow;
}

export interface ModifyProvidedServiceTimeWindowCommand extends Omit<ModifyProvidedServiceTimeWindowRequest, 'type'> {
    type: typeof OrderUpdateCommandType.ModifyProvidedServiceTimeWindow;
}

/**
 * Discriminated union of all order update commands
 */
export type OrderUpdateCommand = ModifyDeliveryTimeWindowCommand | ModifyProvidedServiceTimeWindowCommand;

const isOrderUpdateCommand = (value: unknown): value is OrderUpdateCommand => {
    if (value === null || typeof value !== 'object') {
        return false;
    }
    const commandTypes: string[] = Object.values(OrderUpdateCommandType);
    return 'type' in value && typeof value.type === 'string' && commandTypes.includes(value.type);
};

const orderUpdateCommandsSchema = z.array(z.custom<OrderUpdateCommand>(isOrderUpdateCommand)).min(1);

export const orderUpdateInputSchema = z.object({
    orderId: z.string().min(1),
    commands: orderUpdateCommandsSchema,
});

export type OrderUpdateInput = z.infer<typeof orderUpdateInputSchema>;

export {
    type ModifyDeliveryTimeWindowRequestDeliveryTimeWindow,
    type ModifyProvidedServiceTimeWindowRequestServiceTimeWindowsInner,
} from '@repo/api-types/order-update';
